import { useNavigate } from "react-router-dom";

export default function useQuotationUtils() {
  const navigate = useNavigate();
  const items = [
    {
      label: "Transportation Type",
      icon: "pi pi-list-check",
      command: () => {
        navigate(`/business/quotation-utils/util-transport-type`);
      },
    },
    {
      label: "Transportation Location",
      icon: "pi pi-list-check",
      command: () => {
        navigate(`/business/quotation-utils/util-transport-location`);
      },
    },
    {
      label: "Activity Type",
      icon: "pi pi-list-check",
      command: () => {
        navigate(`/business/quotation-utils/util-activity-type`);
      },
    },
  ];
  return {
    items,
  };
}
